module.exports = __webpack_public_path__ + "7647af4135ab6fc62056c7f20cc241ce.svg";